export const BUMBLEBEE_TITLE_PREFIX = "🐝 BumbleBee · ";

const LEGACY_BUMBLEBEE_TITLE_PREFIX = "BumbleBee · ";

export function getBumblebeeTitleSuffix(
	displayTitle: string,
	fallbackSuffix = "",
): string {
	const normalized = displayTitle.trim();
	if (normalized.startsWith(BUMBLEBEE_TITLE_PREFIX)) {
		return normalized.slice(BUMBLEBEE_TITLE_PREFIX.length).trim();
	}
	if (normalized.startsWith(LEGACY_BUMBLEBEE_TITLE_PREFIX)) {
		return normalized.slice(LEGACY_BUMBLEBEE_TITLE_PREFIX.length).trim();
	}
	return normalized || fallbackSuffix;
}

export function buildBumblebeeDisplayTitle(suffix: string): string {
	return `${BUMBLEBEE_TITLE_PREFIX}${suffix.trim()}`;
}

export function openCampaignCard(campaignId: string): void {
	const url = new URL(
		`/main/campaign/${encodeURIComponent(campaignId)}`,
		window.location.origin,
	);
	window.open(url.toString(), "_blank", "noopener,noreferrer");
}

export function formatUnreadCount(count: number): string {
	if (count > 99) return "99+";
	return String(Math.max(0, count));
}
